import {Link} from "react-router-dom";
import clsx from 'clsx'

import { Container } from '../components/Container'
import {
    TwitterIcon,
} from '../components/SocialIcons'
import portraitImage from '/images/portrait.jpg'
import {Helmet} from "react-helmet-async";
import {Header} from "../components/Header.jsx";
import {Footer} from "../components/Footer.jsx";

function SocialLink({ className, href, children, icon: Icon }) {
    return (
        <li className={clsx(className, 'flex')}>
            <Link
                href={href}
                className="group flex text-sm font-medium text-zinc-800 transition hover:text-teal-500 dark:text-zinc-200 dark:hover:text-teal-500"
            >
                <Icon className="h-6 w-6 flex-none fill-zinc-500 transition group-hover:fill-teal-500" />
                <span className="ml-4">{children}</span>
            </Link>
        </li>
    )
}

function MailIcon(props) {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
            <path
                fillRule="evenodd"
                d="M6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6Zm.245 2.187a.75.75 0 0 0-.99 1.126l6.25 5.5a.75.75 0 0 0 .99 0l6.25-5.5a.75.75 0 0 0-.99-1.126L12 12.251 6.245 7.187Z"
            />
        </svg>
    )
}

export const metadata = {
    title: 'About',
    description:
        'I’m Mike Leitz. I live in Nashville, and I help businesses solve their hardest problems with software.',
}

export default function About() {
    return (
        <div>
            <Helmet>
                <title>Michael Leitz</title>
                <meta name="description"
                      content="I'm Leitz, a software guy who's done every job in tech. Based in Nashville, TN. I help people understand the tech world by sharing wisdom acquired in my 25 years of professional delopment experience."/>
                <meta property="og:title" content="Leitz - Home"/>
                <meta
                    property="og:description"
                    content="Personal site of Michael Leitz, prolific software developer and manager"
                />
                <meta property="og:image" content="/images/portrait.jpg"/>
                <meta property="og:type" content="website"/>
            </Helmet>
            <Header />
            <main className="main flex flex-col items-center py-10">
                <Container className="mt-16 sm:mt-32">
                    <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:grid-rows-[auto_1fr] lg:gap-y-12">
                        <div className="lg:pl-20">
                            <div className="max-w-xs px-2.5 lg:max-w-none">
                                <img
                                    src={portraitImage}
                                    alt=""
                                    sizes="(min-width: 1024px) 32rem, 20rem"
                                    className="aspect-square rotate-3 rounded-2xl bg-zinc-100 object-cover dark:bg-zinc-800"
                                />
                            </div>
                        </div>
                        <div className="lg:order-first lg:row-span-2">
                            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">
                                I’m Mike Leitz!
                            </h1>
                            <br></br>
                            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">I live in
                                Nashville</h1>
                            <br></br>
                            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">I work with Software</h1>

                            <div className="mt-6 space-y-7 text-base text-zinc-600 dark:text-zinc-400">
                                <p>
                                    My entire life I've been obsessed with technology and have worked 20+ years professionally in all aspects
                                    of software creation.

                                    I help businesses solve their hardest problems with software
                                </p>
                                <p>
                                    I'm the creator of <a href="https://LicketyScript.app">Lickety Script</a> — a better way to create Bash
                                    scripts.
                                </p>
                            </div>
                        </div>
                        <div className="lg:pl-20">
                            <ul role="list">
                                <SocialLink href="https://x.com/mleitz1" icon={TwitterIcon}>
                                    mleitz1 on Twitter
                                </SocialLink>
                                <SocialLink
                                    href="mailto:leitz@mikeleitz.com"
                                    icon={MailIcon}
                                    className="border-t border-zinc-100 pt-3dark:border-zinc-700/40"
                                >
                                    leitz@mikeleitz.com
                                </SocialLink>
                            </ul>
                        </div>
                    </div>
                </Container>
            </main>
            <Footer />
        </div>
    )
}
